import { FC } from 'react';

import classes from 'classnames';
import { prop } from 'ramda';

import Text from 'components/shared/Typography/Text';

import styles from './index.module.css';
import { IDefaultLabelProps } from './types';

const DefaultLabel: FC<IDefaultLabelProps> = ({
  children,
  className,
  htmlFor,
  hintRight,
  noTransform,
  withBorder,
  bold,
  ...rest
}) => {
  const defaultLabelClasses = classes(
    styles.label,
    noTransform && prop('label-noTransform', styles),
    withBorder && styles.border,
    bold && prop('label-bold', styles),
    className,
    'custom-input-label',
  );

  return (
    <label className={defaultLabelClasses} htmlFor={htmlFor}>
      <Text {...rest}>{children}</Text>

      {hintRight && (
        <Text className={styles.hintRight} isDisabled>
          {hintRight}
        </Text>
      )}
    </label>
  );
};

export default DefaultLabel;
